import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MidiInput = ({input, midiEngine, syncedInput, setSyncedInput}) => { 
    let [tracked, setTracked] = useState(midiEngine.isInputTracked(input));
    let synced = syncedInput === input;

    const onClickSynced = useCallback(() => {
        if (!midiEngine.isInputSynced(input)) {
            midiEngine.syncInput(input);
            setSyncedInput(input);
        } else {
            midiEngine.unsyncInput(input);
            setSyncedInput(undefined);
        }
        
    }, [setSyncedInput]);

    const onClickTracked = useCallback((x) => {
        if (!midiEngine.isInputTracked(input)) {
            midiEngine.trackInput(input);
        } else {
            midiEngine.untrackInput(input);
        }
        setTracked(!tracked);
    }, [setTracked, tracked]);

    return (
        <div className="midi-input">
          <div className="midi-name">{input.name}</div>
          <div className="midi-options">
              <div
                onClick={onClickTracked}
                className={tracked ? "midi-option enabled" : "midi-option"}>
                TRACK
              </div>
              <div
                onClick={onClickSynced}
                className={synced ? "midi-option enabled" : "midi-option"}>
                SYNC
              </div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MidiInput);
